import * as React from 'react';

import { ApplicationSetting, CurrentUser } from '../models';
import { useApplicationSettingsQuery, useCurrentUserQuery } from '../hooks';

type AuthContext = {
	authToken: string;
	isAuthenticated: boolean;
	isLoading: boolean;
	currentUser: CurrentUser;
	settings: ApplicationSetting[] | undefined;
};

const Context = React.createContext<AuthContext | null>(null);

export const AuthProvider: React.FC = ({ children }) => {
	const apiAuthCookie = document.cookie?.split('; ').find(cookie => cookie.includes('CerebroCapitalApiAuth'));
	const authToken = apiAuthCookie ? apiAuthCookie.split('=')[1] : '';

	const isAuthenticated = authToken !== '' && apiAuthCookie != undefined;

	const currentUserQuery = useCurrentUserQuery(authToken, { enabled: isAuthenticated });
	const settingsQuery = useApplicationSettingsQuery(authToken, { enabled: isAuthenticated });

	const context: AuthContext = {
		authToken,
		isAuthenticated,
		isLoading: currentUserQuery.isLoading || settingsQuery.isLoading,
		currentUser: currentUserQuery.data,
		settings: settingsQuery.data,
	};

	return <Context.Provider value={context}>{children}</Context.Provider>;
};

export function useAuth() {
	var context = React.useContext(Context);

	if (context == null) throw Error('You tried to consume the AuthContext outside of an AuthProvider!');

	return context;
}
